import { render, staticRenderFns } from "./ReferenceTableItem2.vue?vue&type=template&id=cc7bb6e4&"
import script from "./ReferenceTableItem2.vue?vue&type=script&lang=js&"
export * from "./ReferenceTableItem2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports